<template>
  <div class="annotation">
    <confirmation-dialog
      message-title="CONFIRMAÇÃO"
      :message-body="confirm_message"
      hide-open-button
      @yes="create"
      v-model="confirm_visible"
    />
    <vs-button
      @click="handleOpenModalCreateAnnotations"
      class="btn-annotation ml-1"
      type="relief"
      ><i class="fas fa-pencil-alt mr-2 text-twenty"></i>ANOTAÇÕES</vs-button
    >
    <!-- Modal create annotation -->
    <b-modal no-close-on-backdrop hide-footer size="xl" id="popupAnnotations">
      <template #modal-header="{ close }">
        <h5 class="modal-title mb-0">ADICIONAR ANOTAÇÃO</h5>
        <confirmation-dialog
          open-class="btn-close-modal"
          yes-class="btn-delete"
          open-left-icon="fa-times"
          message-title="Deseja realmente cancelar?"
          message-body="Ao cancelar, não serão salvas quaisquer informações que foram adicionadas nas anotações!"
          @yes="close"
        />
      </template>
      <form>
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a
              @click="errors = []"
              class="nav-link active link-annotation-care"
              id="nav-passagem-de-plantao"
              data-toggle="tab"
              href="#passagem-de-plantao"
              role="tab"
              aria-controls="passagem-de-plantao"
              aria-selected="true"
              >PASSAGEM DE PLANTÃO</a
            >
            <a
              @click="errors = []"
              class="nav-link link-annotation-care"
              id="nav-anotacao"
              data-toggle="tab"
              href="#anotacao"
              role="tab"
              aria-controls="anotacao"
              aria-selected="false"
              >ANOTAÇÃO</a
            >
            <a
              @click="errors = []"
              class="nav-link link-annotation-care"
              id="nav-alimentacao"
              data-toggle="tab"
              href="#alimentacao"
              role="tab"
              aria-controls="alimentacao"
              aria-selected="false"
              >ALIMENTAÇÃO</a
            >
            <a
              @click="errors = []"
              class="nav-link link-annotation-care"
              id="nav-banho"
              data-toggle="tab"
              href="#banho"
              role="tab"
              aria-controls="banho"
              aria-selected="false"
              >BANHO</a
            >
            <!-- <a
              @click="errors = []"
              class="nav-link link-annotation-care"
              id="nav-curativo"
              data-toggle="tab"
              href="#curativo"
              role="tab"
              aria-controls="curativo"
              aria-selected="false"
              >CURATIVO</a
            > -->
            <!-- <a
              @click="errors = []"
              class="nav-link link-annotation-care"
              id="nav-troca-de-fralda"
              data-toggle="tab"
              href="#troca-de-fralda"
              role="tab"
              aria-controls="troca-de-fralda"
              aria-selected="false"
              >TROCA DE FRALDA</a
            > -->
            <a
              @click="errors = []"
              class="nav-link link-annotation-care"
              id="nav-resumo-da-anotacao-termino"
              data-toggle="tab"
              href="#resumo-da-anotacao-termino"
              role="tab"
              aria-controls="resumo-da-anotacao-termino"
              aria-selected="false"
              >RESUMO DA ANOTAÇÃO</a
            >
          </div>
        </nav>
        <div class="tab-content">
          <div
            class="tab-pane fade show active"
            id="passagem-de-plantao"
            role="tabpanel"
            aria-labelledby="nav-passagem-de-plantao"
          >
            <div class="row">
              <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-12">
                <h6>PERÍODO:</h6>
                <div class="row ml-1">
                  <vs-radio
                    v-model="shift_change_beginning_or_end"
                    vs-value="INICIO"
                    class="m-2"
                    >INÍCIO</vs-radio
                  >
                  <vs-radio
                    v-model="shift_change_beginning_or_end"
                    vs-value="FIM"
                    class="m-2"
                    >FIM</vs-radio
                  >
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-5 col-sm-8 col-12">
                <h6>RESIDENTE ESTÁ:</h6>
                <select
                  v-model="place"
                  @change="handleChangePlace"
                  class="form-control"
                >
                  <option value data-name>SELECIONE...</option>
                  <option
                    :key="item.id"
                    :value="item.name"
                    :data-name="item.name"
                    v-for="item in places"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <div v-show="show_other_place" class="mt-2">
                  <h6>LOCAL:</h6>
                  <input
                    v-model="other_place"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-5 col-sm-12 col-12">
                <h6>CONDIÇÃO:</h6>
                <div class="row">
                  <div class="check-box-annotation">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="shift_change_ACORDADO"
                      v-model="shift_change_ACORDADO"
                    />
                    <label class="form-check-label" for="shift_change_ACORDADO"
                      >ACORDADO</label
                    >
                  </div>
                  <div class="check-box-annotation">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="shift_change_AGITADO"
                      v-model="shift_change_AGITADO"
                    />
                    <label class="form-check-label" for="shift_change_AGITADO"
                      >AGITADO</label
                    >
                  </div>
                  <div class="check-box-annotation">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="shift_change_CALMO"
                      v-model="shift_change_CALMO"
                    />
                    <label class="form-check-label" for="shift_change_CALMO"
                      >CALMO</label
                    >
                  </div>
                  <div class="check-box-annotation">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="shift_change_CONTACTUADO"
                      v-model="shift_change_CONTACTUADO"
                    />
                    <label
                      class="form-check-label"
                      for="shift_change_CONTACTUADO"
                      >CONTACTUANDO</label
                    >
                  </div>
                  <div class="check-box-annotation">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="shift_change_DEAMBULANDO"
                      v-model="shift_change_DEAMBULANDO"
                    />
                    <label
                      class="form-check-label"
                      for="shift_change_DEAMBULANDO"
                      >DEAMBULANDO</label
                    >
                  </div>
                  <div class="check-box-annotation">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="shift_change_DORMINDO"
                      v-model="shift_change_DORMINDO"
                    />
                    <label class="form-check-label" for="shift_change_DORMINDO"
                      >DORMINDO</label
                    >
                  </div>
                  <div class="check-box-annotation">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="shift_change_HIDRATADO"
                      v-model="shift_change_HIDRATADO"
                    />
                    <label class="form-check-label" for="shift_change_HIDRATADO"
                      >HIDRATADO</label
                    >
                  </div>
                  <div class="check-box-annotation">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="shift_change_SENTADO"
                      v-model="shift_change_SENTADO"
                    />
                    <label class="form-check-label" for="shift_change_SENTADO"
                      >SENTADO</label
                    >
                  </div>
                  <div class="check-box-annotation">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="shift_change_SONOLENTO"
                      v-model="shift_change_SONOLENTO"
                    />
                    <label class="form-check-label" for="shift_change_SONOLENTO"
                      >SONOLENTO</label
                    >
                  </div>
                  <div class="check-box-annotation">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="shift_change_OUTROS"
                      v-model="shift_change_OUTROS"
                      @input="handleChangeShiftChangeResponse"
                    />
                    <label class="form-check-label" for="shift_change_OUTROS"
                      >OUTROS</label
                    >
                  </div>
                  <div
                    v-if="show_other_shift_change_response"
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                  >
                    <h6 class="upper-text">Informe a condicão:</h6>
                    <ChromeSpeechToTextTextarea
                      rows="4"
                      max-rows="10"
                      v-model="other_shift_change_response"
                    />
                  </div>
                </div>
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0"
              >
                <ErrorsMessages :errors="errors" />
              </div>
            </div>
            <div class="row back-groung-greytwo mt-4">
              <div
                class="
                  col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12
                  check-text-center
                  pb-0
                "
              >
                <h6 class="upper-text">
                  LISTA DE PASSAGEM DE PLANTÃO ADICIONADOS
                </h6>
              </div>
              <div
                class="
                  col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12
                  check-text-right
                  nb-margin
                  pb-0
                "
              >
                <v-btn class="btn-add-down" @click="handleAddShiftChange">
                  <i class="fas fa-arrow-down mr-2 text-twenty"></i>
                  ADICIONAR À LISTA
                </v-btn>
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                v-if="shift_changes.length == 0"
              >
                <div class="v-clean p-5">
                  <h6 class="text-center upper-text worksansr">
                    Nenhuma informação adicionada.
                  </h6>
                </div>
              </div>
              <div class="col-md-12" v-if="shift_changes.length > 0">
                <v-data-table
                  dense
                  :headers="[
                    {
                      text: 'PERÍODO',
                      sortable: false,
                      value: 'beginning_or_end',
                    },
                    {
                      text: 'RESIDENTE ESTÁ',
                      value: 'place',
                    },
                    { text: 'CONDIÇÃO', value: 'response' },
                    { text: 'Ações', value: 'actions' },
                  ]"
                  :items="shift_changes"
                  :footer-props="{
                    'items-per-page-options': [50, 75, 100],
                    'items-per-page-text': 'Mostrar',
                  }"
                >
                  <template v-slot:[`item.response`]="{ item }">
                    {{ item.response.join(" ") }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <confirmation-dialog
                      small
                      message-title="EXCLUIR?"
                      message-body="Deseja realmente remover?"
                      open-class="btn-delete"
                      open-text="REMOVER"
                      @yes="deleteShiftChange(item.id)"
                    />
                  </template>
                </v-data-table>
              </div>
            </div>
            <div class="row">
              <div
                class="
                  col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                  pb-0
                  text-right
                "
              >
                <v-btn
                  :disabled="loadingCreate || shift_changes.length == 0"
                  @click="handleToCreate"
                  class="btn-notcertified"
                >
                  <i class="fas fa-check mr-2 text-twenty"></i>
                  SALVAR
                  {{
                    loadingCreate ? "Carregando" : "COM ASSINATURA ELETRÔNICA"
                  }}
                </v-btn>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="anotacao"
            role="tabpanel"
            aria-labelledby="nav-anotacao"
          >
            <div class="row">
              <div class="col-md-12">
                <ChromeSpeechToTextTextarea
                  rows="4"
                  max-rows="10"
                  v-model="annotation"
                />
              </div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <h6 class="mb-0 worksansr upper-text text-fourteen">
                  Gerado por:
                  <strong>
                    {{
                      professionalClassCouncilValue({
                        id: user.professional_class_council_id,
                        name: user.name,
                        profile: user.profile_name,
                        office: user.office,
                        cpf: user.cpf,
                        value: user.professional_class_council_value,
                      })
                    }}
                  </strong>
                </h6>
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
              >
                <WarningMessage
                  class="text-thirteen text-center pt-2"
                  message="Após SALVAR ainda será possível adicionar mais informações."
                />
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0"
              >
                <ErrorsMessages :errors="errors" />
              </div>
              <div
                class="
                  col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                  text-right
                "
              >
                <v-btn
                  :disabled="loadingCreate"
                  @click="handleToCreate"
                  class="btn-notcertified"
                >
                  <i class="fas fa-check mr-2 text-twenty"></i>
                  SALVAR
                  {{
                    loadingCreate ? "Carregando" : "COM ASSINATURA ELETRÔNICA"
                  }}
                </v-btn>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="alimentacao"
            role="tabpanel"
            aria-labelledby="nav-alimentacao"
          >
            <div class="row">
              <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-12">
                <h6>HORÁRIO DA REFEIÇÃO:</h6>
                <select
                  v-model="feeding_care_id"
                  @change="handleChangeFeedingCare"
                  class="form-control"
                >
                  <option value data-name>SELECIONE...</option>
                  <option
                    :key="item.id"
                    :value="item.id"
                    :data-name="item.name"
                    v-for="item in feeding_cares"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-12">
                <h6>ACEITOU A REFEIÇÃO?</h6>
                <div class="input-group">
                  <select v-model="feeding_care_response" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      :key="item.id"
                      :value="item.response"
                      v-for="item in feeding_care_responses"
                    >
                      {{ item.response }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
              >
                <ErrorsMessages :errors="errors" />
              </div>
            </div>
            <div class="row back-groung-greytwo mt-4">
              <div
                class="
                  col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12
                  check-text-center
                  pb-0
                "
              >
                <h6 class="upper-text">Lista de Alimentação adicionada</h6>
              </div>
              <div
                class="
                  col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12
                  check-text-right
                  nb-margin
                  pb-0
                "
              >
                <v-btn class="btn-add-down" @click="handleAddFeedingCare">
                  <i class="fas fa-arrow-down mr-2 text-twenty"></i>
                  ADICIONAR À LISTA
                </v-btn>
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                v-if="feeding_cares_added.length == 0"
              >
                <div class="v-clean p-5">
                  <h6 class="text-center upper-text worksansr">
                    Nenhuma informação adicionada.
                  </h6>
                </div>
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                v-if="feeding_cares_added.length > 0"
              >
                <v-data-table
                  dense
                  :headers="[
                    { text: 'Refeição', value: 'name' },
                    { text: 'Resposta', value: 'response' },
                    { text: 'Ações', value: 'actions' },
                  ]"
                  :items="feeding_cares_added"
                  :footer-props="{
                    'items-per-page-options': [50, 75, 100],
                    'items-per-page-text': 'Mostrar',
                  }"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <confirmation-dialog
                      small
                      message-title="EXCLUIR?"
                      message-body="Deseja realmente remover?"
                      open-class="btn-delete"
                      open-left-icon="fa-trash"
                      open-text="EXCLUIR"
                      @yes="deleteFeedingCare(item.key)"
                    />
                  </template>
                </v-data-table>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0">
                <WarningMessage
                  class="text-thirteen text-center pt-2"
                  message="Após SALVAR ainda será possível adicionar mais informações."
                />
              </div>
              <div
                class="
                  col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                  pt-0
                  pb-0
                  text-right
                "
              >
                <v-btn
                  :disabled="loadingCreate || feeding_cares_added.length == 0"
                  @click="handleToCreate"
                  class="btn-notcertified"
                >
                  <i class="fas fa-check mr-2 text-twenty"></i>
                  SALVAR
                  {{
                    loadingCreate ? "Carregando" : "COM ASSINATURA ELETRÔNICA"
                  }}
                </v-btn>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="banho"
            role="tabpanel"
            aria-labelledby="nav-banho"
          >
            <div class="row">
              <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-12">
                <h6>TURNO:</h6>
                <select v-model="shift" class="form-control">
                  <option value data-name>SELECIONE...</option>
                  <option
                    :key="item.id"
                    :value="item.name"
                    :data-name="item.name"
                    v-for="item in shifts"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-12">
                <h6>TIPO:</h6>
                <div class="input-group">
                  <select v-model="bath_type" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      :key="item.id"
                      :value="item.name"
                      v-for="item in bath_types"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row back-groung-greytwo mt-4">
              <div
                class="
                  col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12
                  check-text-center
                  pb-0
                "
              >
                <h6 class="upper-text">LISTA DE BANHO ADICIONADOS</h6>
              </div>
              <div
                class="
                  col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12
                  check-text-right
                  nb-margin
                  pb-0
                "
              >
                <v-btn class="btn-add-down" @click="handleAddBath">
                  <i class="fas fa-arrow-down mr-2 text-twenty"></i>
                  ADICIONAR À LISTA
                </v-btn>
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
              >
                <ErrorsMessages :errors="errors" />
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                v-if="baths.length == 0"
              >
                <div class="v-clean p-5">
                  <h6 class="text-center upper-text worksansr">
                    Nenhuma informação adicionada.
                  </h6>
                </div>
              </div>
              <div class="col-md-12" v-if="baths.length > 0">
                <v-data-table
                  dense
                  :headers="[
                    { text: 'TURNO', value: 'shift' },
                    { text: 'TIPO', value: 'bath_type' },
                  ]"
                  :items="baths"
                  :footer-props="{
                    'items-per-page-options': [50, 75, 100],
                    'items-per-page-text': 'Mostrar',
                  }"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <confirmation-dialog
                      small
                      message-title="EXCLUIR?"
                      message-body="Deseja realmente remover?"
                      open-class="btn-delete"
                      open-left-icon="fa-trash"
                      open-text="EXCLUIR"
                      @yes="deleteBath(item.id)"
                    />
                  </template>
                </v-data-table>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0">
                <WarningMessage
                  class="text-thirteen text-center pt-2"
                  message="Após SALVAR ainda será possível adicionar mais informações."
                />
              </div>
              <div
                class="
                  col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                  pt-1
                  pb-0
                  text-right
                "
              >
                <v-btn
                  :disabled="loadingCreate || baths.length == 0"
                  @click="handleToCreate"
                  class="btn-notcertified"
                >
                  <i class="fas fa-check mr-2 text-twenty"></i>
                  SALVAR
                  {{
                    loadingCreate ? "Carregando" : "COM ASSINATURA ELETRÔNICA"
                  }}
                </v-btn>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="resumo-da-anotacao-termino"
            role="tabpanel"
            aria-labelledby="nav-resumo-da-anotacao-termino"
          >
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0">
              <span class="worksansr upper-text weight-600">
                Assumo o plantão, cliente no(a)
              </span>
              <span
                v-for="item in shift_changes"
                :key="item.id"
                class="worksansr upper-text"
                v-show="item.beginning_or_end == 'INICIO'"
              >
                {{ item.place }} - {{ item.response.join(" ") }};
              </span>

              <span
                v-for="item in feeding_cares_added"
                :key="item.id"
                class="worksansr upper-text pr-1"
              >
                {{ item.name }}: {{ item.response }};
              </span>

              <span
                v-for="item in baths"
                :key="item.id"
                class="worksansr upper-text pr-1"
              >
                Realizado o banho de
                {{ item.shift }} - {{ item.bath_type }};
              </span>
              <h6 class="upper-text mt-2">
                Observação:
                <span class="worksansr upper-text">{{ annotation }}</span>
              </h6>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0">
              <h6 class="upper-text">Encerro o plantão, cliente no(a)</h6>
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
            >
              <span
                v-for="item in shift_changes"
                :key="item.id"
                class="worksansr upper-text"
                v-show="item.beginning_or_end == 'FIM'"
                >{{ item.place }} - {{ item.response.join(" ") }};</span
              >
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
              <h6 class="mb-0 text-thirteen">
                {{
                  professionalClassCouncilValue({
                    id: user.professional_class_council_id,
                    name: user.name,
                    cpf: user.cpf,
                    office: user.office,
                    value: user.professional_class_council_value,
                  })
                }}.
              </h6>
              <span class="upper-text text-eleven"
                >(Assinatura eletrônica)</span
              >
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
            >
              <WarningMessage
                class="text-thirteen text-center pt-2"
                message="Após SALVAR ainda será possível adicionar mais informações."
              />
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
            >
              <v-btn
                :disabled="loadingCreate"
                @click="handleToCreate"
                class="btn-notcertified"
              >
                <i class="fas fa-check mr-2 text-twenty"></i>
                SALVAR
                {{ loadingCreate ? "Carregando" : "COM ASSINATURA ELETRÔNICA" }}
              </v-btn>
            </div>
            <div class="col-md-12">
              <ErrorsMessages :errors="errors" />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- /Modal create annotation -->
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";
import WarningMessage from "../../../Components/WarningMessage";

import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import {
  formatDate,
  generateId,
  isNumeric,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import routes from "../../../../routes";
import { userData } from "../../../../lib/functions";

import { isValidAmount } from "../../../../lib/amount";
import ConfirmationDialog from "../../../Components/ConfirmationDialog.vue";

export default {
  name: "VitalSigns",
  components: {
    ErrorsMessages,
    WarningMessage,
    ChromeSpeechToTextTextarea,
    ConfirmationDialog,
  },
  props: {
    type: [String, Number],
    rest_home_id: [String, Number],
    resident_id: [String, Number],
    user_id: [String, Number],
  },
  data() {
    return {
      confirm_message: "",
      confirm_visible: false,
      searchMedicines: "",
      searchProducts: "",
      user: {},
      medicines: [],
      feeding_cares: [],
      shift_changes: [],
      baths: [],
      feeding_cares_added: [],
      shifts: [
        { id: 1, name: "MANHÃ" },
        { id: 2, name: "TARDE" },
        { id: 3, name: "NOITE" },
        { id: 4, name: "MADRUGADA" },
      ],
      bath_types: [
        { id: 1, name: "ASPERSÃO" },
        { id: 2, name: "LEITO" },
      ],
      places: [
        { id: 1, name: "AUSENTE" },
        { id: 3, name: "BANHEIRO" },
        { id: 5, name: "LEITO" },
        { id: 6, name: "OUTROS" },
        { id: 4, name: "QUINTAL" },
        { id: 2, name: "SALA" },
      ],
      shift_change_SONOLENTO: false,
      shift_change_DORMINDO: false,
      shift_change_ACORDADO: false,
      shift_change_AGITADO: false,
      shift_change_CONTACTUADO: false,
      shift_change_SENTADO: false,
      shift_change_HIDRATADO: false,
      shift_change_DEAMBULANDO: false,
      shift_change_CALMO: false,
      shift_change_OUTROS: false,
      feeding_care_responses: [
        { id: 1, response: "ACEITOU PARCIAL" },
        { id: 2, response: "BOA ACEITAÇÃO" },
        { id: 3, response: "NÃO ACEITOU" },
        { id: 4, response: "RESIDENTE AUSENTE" },
      ],
      annotation: "",
      feeding_care_id: "",
      feeding_care_response: "",
      feeding_care_response_name: "",
      shift: "",
      bath_type: "",
      shift_change_beginning_or_end: "",
      place: "",
      shift_change_response: "",
      other_place: "",
      other_shift_change_response: "",
      show_other_place: false,
      show_other_shift_change_response: false,
      medicine: {},
      medicine_amount: "",
      product: {},
      product_amount: "",
      loadingCreate: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    generateId,
    isNumeric,
    isValidAmount,
    professionalClassCouncilValue,
    handleChangePlace(e) {
      const { value } = e.target;

      if (value == "OUTROS") {
        this.show_other_place = true;
      } else {
        this.show_other_place = false;
      }
    },
    handleChangeShiftChangeResponse(e) {
      const { checked } = e.target;

      if (checked) {
        this.show_other_shift_change_response = true;
      } else {
        this.show_other_shift_change_response = false;
      }
    },
    handleChangeFeedingCare(e) {
      const { options } = e.target;
      const { selectedIndex } = e.target.options;

      var option = options[selectedIndex];

      this.feeding_care_response_name = option.dataset.name;
    },
    async retrieve() {
      this.user = userData().user;

      if (this.errors.length == 0) await this.getFeedingCares();
      if (this.errors.length == 0) await this.getLastAnnotation();
    },
    async getLastAnnotation() {
      try {
        const { resident_id } = this;

        var params = {
          resident_id,
        };

        const response = await api.get("/rest-home/care/annotation/last", {
          params,
        });
        const { error, errors, annotation } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          this.last_annotation = annotation;

          if (annotation && annotation.id) {
            if (annotation.care_has_shift_change) {
              for (let item of annotation.care_has_shift_change) {
                if (item.beginning_or_end == "FIM") {
                  let obj = {
                    id: generateId(),
                    beginning_or_end: "INICIO",
                    place: item.place,
                    response: [item.response],
                    created_at: new Date().toISOString(),
                  };

                  this.shift_changes.push(obj);
                }
              }
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getFeedingCares() {
      try {
        const response = await api.get("/feeding-cares");

        const { error, errors, feeding_cares } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.feeding_cares = feeding_cares;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleOpenModalCreateAnnotations() {
      try {
        const { resident_id } = this;

        const response = await api.get("/rest-home/annotation/exist-by-user", {
          params: { resident_id },
        });

        const { error, errors, exist, id } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          if (exist) {
            return routes.push({ name: "care", params: { id } });
          } else {
            this.$bvModal.show("popupAnnotations");
            this.errors = [];
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleAddFeedingCare() {
      const {
        feeding_care_response,
        feeding_care_response_name,
        feeding_care_id,
      } = this;

      if (!feeding_care_id) {
        this.errors = [
          {
            id: this.errors.length + 1,
            message: "Informe o horário",
          },
        ];
        return;
      }

      if (!feeding_care_response) {
        this.errors = [
          {
            id: this.errors.length + 1,
            message: "Informe a aceitação da REFEIÇÃO",
          },
        ];
        return;
      }

      var obj = {
        id: feeding_care_id,
        key: generateId(),
        name: feeding_care_response_name,
        response: feeding_care_response,
        created_at: new Date().toISOString(),
      };

      this.feeding_cares_added.push(obj);

      this.feeding_care_id = "";
      this.feeding_care_response = "";
      this.errors = [];
    },
    deleteFeedingCare(id) {
      try {
        const { feeding_cares_added } = this;

        feeding_cares_added.map((item, key) => {
          if (item.key == id) {
            feeding_cares_added.splice(key, 1);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    handleAddBath() {
      const { shift, bath_type } = this;

      if (!shift) {
        this.errors = [
          { id: this.errors.length + 1, message: "Informe o turno" },
        ];
        return;
      }

      if (!bath_type) {
        this.errors = [
          { id: this.errors.length + 1, message: "Informe o tipo" },
        ];
        return;
      }

      var obj = {
        id: generateId(),
        shift,
        bath_type,
        created_at: new Date().toISOString(),
      };

      this.baths.push(obj);

      this.shift = "";
      this.bath_type = "";
      this.errors = [];
    },
    deleteBath(id) {
      try {
        const { baths } = this;

        baths.map((item, key) => {
          if (item.id == id) {
            baths.splice(key, 1);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    handleAddShiftChange() {
      const {
        shift_change_beginning_or_end: beginning_or_end,
        place,
        other_place,
        other_shift_change_response,
        shift_changes,
        shift_change_SONOLENTO,
        shift_change_DORMINDO,
        shift_change_ACORDADO,
        shift_change_AGITADO,
        shift_change_CONTACTUADO,
        shift_change_SENTADO,
        shift_change_HIDRATADO,
        shift_change_DEAMBULANDO,
        shift_change_CALMO,
        shift_change_OUTROS,
      } = this;

      if (!beginning_or_end) {
        this.errors = [
          { id: this.errors.length + 1, message: "Informe O PERÍODO" },
        ];
        return;
      }

      for (let i = 0; i < shift_changes.length; i++) {
        if (shift_changes[i].beginning_or_end == beginning_or_end) {
          this.errors = [
            {
              id: this.errors.length + 1,
              message: `${beginning_or_end} Já cadastrado`,
            },
          ];
          return;
        }
      }

      if (place != "AUSENTE") {
        if (!place) {
          this.errors = [
            { id: this.errors.length + 1, message: "Informe o local" },
          ];
          return;
        }
      }

      if (place == "OUTROS") {
        if (!other_place) {
          this.errors = [
            { id: this.errors.length + 1, message: "Informe o local" },
          ];
          return;
        }
      }

      var shift_change_response = [];

      if (shift_change_ACORDADO) {
        shift_change_response.push("ACORDADO, ");
      }

      if (shift_change_AGITADO) {
        shift_change_response.push("AGITADO, ");
      }

      if (shift_change_CALMO) {
        shift_change_response.push("CALMO, ");
      }

      if (shift_change_CONTACTUADO) {
        shift_change_response.push("CONTACTUANDO, ");
      }

      if (shift_change_DEAMBULANDO) {
        shift_change_response.push("DEAMBULANDO, ");
      }

      if (shift_change_DORMINDO) {
        shift_change_response.push("DORMINDO, ");
      }

      if (shift_change_HIDRATADO) {
        shift_change_response.push("HIDRATADO, ");
      }

      if (shift_change_SENTADO) {
        shift_change_response.push("SENTADO, ");
      }

      if (shift_change_SONOLENTO) {
        shift_change_response.push("SONOLENTO, ");
      }

      if (place != "AUSENTE" && !shift_change_OUTROS) {
        if (shift_change_response.length <= 0) {
          this.errors = [
            { id: this.errors.length + 1, message: "Informe a condição" },
          ];
          return;
        }
      }

      if (shift_change_OUTROS) {
        if (!other_shift_change_response) {
          this.errors = [
            {
              id: this.errors.length + 1,
              message: "Informe a Condição (outros)",
            },
          ];
          return;
        }

        shift_change_response.push(
          String(other_shift_change_response).toUpperCase()
        );
      }

      if (shift_change_response.length > 0) {
        if (!shift_change_OUTROS) {
          shift_change_response[shift_change_response.length - 1] =
            shift_change_response[shift_change_response.length - 1].replace(
              ", ",
              ""
            );
        }
      }

      var obj = {
        id: generateId(),
        beginning_or_end,
        place: other_place ? other_place : place,
        response: shift_change_response,
        created_at: new Date().toISOString(),
      };

      this.shift_changes.push(obj);

      this.shift_change_beginning_or_end = "";
      this.place = "";
      this.other_place = "";
      this.other_shift_change_response = "";
      this.shift_change_SONOLENTO = false;
      this.shift_change_DORMINDO = false;
      this.shift_change_ACORDADO = false;
      this.shift_change_AGITADO = false;
      this.shift_change_CONTACTUADO = false;
      this.shift_change_SENTADO = false;
      this.shift_change_HIDRATADO = false;
      this.shift_change_DEAMBULANDO = false;
      this.shift_change_CALMO = false;
      this.shift_change_OUTROS = false;
      this.show_other_place = false;
      this.show_other_shift_change_response = false;
      this.errors = [];
    },
    deleteShiftChange(id) {
      try {
        const { shift_changes } = this;

        shift_changes.map((item, key) => {
          if (item.id == id) {
            shift_changes.splice(key, 1);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    handleToCreate() {
      let pending = false;

      if (this.shift_change_beginning_or_end) {
        pending =
          "Você adicionou informações na passagem de plantão más não adicionou na anotação.";
      }

      if (this.feeding_care_id) {
        pending =
          "Você adicionou informações na alimentação más não adicionou na anotação.";
      }

      if (this.shift) {
        pending =
          "Você adicionou informações no banho más não adicionou na anotação.";
      }

      if (pending) {
        this.confirm_message = `Deseja realmente SALVAR o cadastro da anotação? ${pending}`;
        this.confirm_visible = true;
      } else {
        this.create();
      }
    },
    async create() {
      try {
        this.loadingCreate = true;

        const { type } = this;

        const {
          rest_home_id,
          resident_id,
          user_id,
          feeding_cares_added: feeding_cares,
          baths,
          shift_changes,
          annotation,
        } = this;

        var params = {
          rest_home_id,
          resident_id,
          user_id,
          feeding_cares,
          baths,
          shift_changes,
          annotation,
          type,
        };

        const response = await api.post("/rest-home/care/create", params);

        const { error, errors, message, care_id } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide("popupAnnotations");
          this.$emit("created");
          routes.push({ name: "care", params: { id: care_id } });
        } else {
          this.errors = errors;
        }

        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.check-box-annotation {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
  position: relative;
  width: 130px;
  margin-left: 35px;
}

.small-title-care {
  margin-bottom: -2px !important;
  font-size: 18px;
}

.small-subtitle-care {
  font-size: 12px;
}

.back-color-title {
  background-color: #f9f9f9;
}
</style>
